/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDataCounter.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setDataCounter = () => {
    let slideLength = document.querySelectorAll(".slider__list-item").length.toString();
    let docDataPosCounter = document.querySelector(".data-pos-counter");
    let dataNum = document.querySelectorAll("[data-num]");
    function setDataPosCounter() {
        let dataPos = docDataPosCounter.dataset.position;
        dataPos === slideLength ? docDataPosCounter.dataset.position = "1" : docDataPosCounter.dataset.position++;
        dataNum.forEach(function (item) {
            item.dataset.num === docDataPosCounter.dataset.position ? item.classList.add("--active") : item.classList.remove("--active");
        });
    }
    setDataPosCounter();
    window.setInterval(() => { setDataPosCounter(); }, 4000);
};

export {
    setDataCounter
}